import { createContext, ReactNode } from "react";

export interface LoadContextType {
  activeLoadId?: string;
}

export const LoadContext = createContext<LoadContextType>({
  activeLoadId: undefined,
});

export interface LoadProviderProps {
  activeLoadId?: string;
  children?: ReactNode;
}

export const LoadProvider = ({ activeLoadId, children }: LoadProviderProps) => {
  return (
    <LoadContext.Provider value={{ activeLoadId }}>
      {children}
    </LoadContext.Provider>
  );
};
